import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-summary-cost-data',
  templateUrl: './summary-cost-data.component.html',
  styleUrls: ['./summary-cost-data.component.css']
})
export class SummaryCostDataComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.SummaryCostData.columns;
    this.data = this.report.SummaryCostData.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.SummaryCostData.data;
    const gridInstance = this.gridContext.getInstance('SummaryCostData');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/summary-cost-data/summary-cost-data.component.ts